import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    AppLoginRequestWithKeycloak,
    LoginRequest,
    LoginResponse,
    RequestLoginOtpRequest,
} from '../shared/schemas';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import * as Sentry from '@sentry/angular';
import Keycloak from 'keycloak-js';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    isLoggedIn = new BehaviorSubject<boolean>(false);
    public keycloak: Keycloak;
    constructor(private readonly http: HttpClient
    ) {
        this.keycloak = new Keycloak({
            url: environment.keycloakUrl,
            realm: environment.keycloakRealm,
            clientId: environment.keycloakClientId,
        });
    }

    requestLoginOtp(body: RequestLoginOtpRequest) {
        return this.http.post<string>(`${environment.baseUrl}/admin/auth/otp`, body);
    }

    loginUser(body: LoginRequest, otp: string, phone: string) {
        const headers = { 'x-engine-otp': otp, 'x-engine-phone': phone };
        return this.http.post<LoginResponse>(`${environment.baseUrl}/admin/auth/login`, body, { headers });
    }

    loginWithKeycloak(body: AppLoginRequestWithKeycloak) {
        return this.http.post<{ data: LoginResponse }>(
            `${environment.drahimApiBaseURL}/backoffice/login_with_keycloak_for_investment_admin`,
            body,
        );
    }

    refreshEngineUserToken(refreshToken: string) {
        const headers = { Authorization: `Bearer ${refreshToken}` };
        return this.http.post<LoginResponse>(
            `${environment.drahimApiBaseURL}/v1/oauth/engines/refresh-engine-token`,
            {},
            { headers },
        );
    }
    logoutUser() {
        return this.http.post<LoginResponse>(`${environment.baseUrl}/admin/auth/logout`, {});
    }

    logoutEngineUser() {
        console.log('request signn out');
        return this.http.post<string>(`${environment.drahimApiBaseURL}/v1/oauth/engines/logout`, {});
    }

    refreshToken(refreshToken: string) {
        const headers = { Authorization: `Bearer ${refreshToken}` };
        return this.http.post<LoginResponse>(`${environment.baseUrl}/admin/auth/refresh`, {}, { headers });
    }

    decodeAndParseJWTToken(token: string) {
        const base64Url = token.split('.')[1];
        if (!base64Url) return {};
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

        const jsonPayload = decodeURIComponent(
            window
                .atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join(''),
        );

        return JSON.parse(jsonPayload);
    }

    setUserContext(accessToken: string) {
        const parsed = this.decodeAndParseJWTToken(accessToken);
        Sentry.setUser({ id: parsed?.sub });
    }

    isJwtExpired(accessToken: string, buffer: number) {
        const parsed = this.decodeAndParseJWTToken(accessToken);
        if (!parsed?.exp) return false;
        const expiryInMillis = parsed.exp * 1000;
        return expiryInMillis - buffer * 1000 < new Date().getTime();
    }
}
